import {
  ApiBlobGetRequest,
  ApiGetRequest,
  // ApiPostRequest,
  // ApiDeleteRequest,
  // ApiPutRequest,
} from '../../../api';
import moment from 'moment-mini';
// import { showNotif } from '../../notification';

export const state = {
  data: {
    title: 'Report - Container Out',
    breadcrumb: [
      {
        text: 'Dashboard',
        href: '/adm/opr/report',
      },
      {
        text: 'Report - Container Out',
        href: '/adm/opr/report/container-out',
        active: true,
      },
    ],
    showmodal: false,
    items: [],
    total: 0,
    page: 1,
    limit: 10,
    pageOptions: [10, 25, 50, 100],
    search: '',
    sortBy: 'id_eir_out',
    sortDesc: true,
    fields: [
      {
        key: 'principle',
        label: 'Principle',
        sortable: true,
      },
      {
        key: 'doc_no',
        label: 'B/L No',
        sortable: true,
      },
      {
        key: 'vessel',
        label: 'Vessel',
        sortable: true,
      },
      {
        key: 'doc_type',
        label: 'Type',
        sortable: true,
      },
      {
        key: 'condition',
        label: 'Condition',
        sortable: true,
      },
      {
        key: 'container',
        label: 'Container',
      },
      {
        key: 'size',
        label: 'Size',
      },
      {
        key: 'type',
        label: 'Type',
      },
      {
        key: 'seal',
        label: 'Seal',
      },
      {
        key: 'tgl_eir_out',
        label: 'Date Out',
        sortable: true,
      },
    ],
    detail: false,
    form: {
      id_principle: '',
      principle_code: '',
      principle_name: '',
      id_shipper: '',
      shipper_code: '',
      shipper_name: '',
    },
  },
};

export const getters = {
  form(state) {
    return state.data.form;
  },
};

export const mutations = {
  reportContOut(state, data) {
    state.data = Object.assign({}, state.data, data);
  },
};

export const actions = {
  async getReportContainerOut({ commit, state }) {
    commit('reportContOut', {
      loading: true,
    });

    const { data } = state;
    let params = {
      q: data.search,
      limit: data.limit,
      page: data.page,
      sort: data.sortBy,
      order: data.sortDesc ? 'desc' : 'asc',
      ...data.form,
      date: '',
      start_date:
        data.form.date && data.form.date.length > 0 && data.form.date[0]
          ? moment(data.form.date[0]).format('YYYY-MM-DD')
          : '',
      end_date:
        data.form.date && data.form.date.length > 0 && data.form.date[1]
          ? moment(data.form.date[1]).format('YYYY-MM-DD')
          : '',
    };

    let result = await ApiGetRequest(`opr/report/container-out`, params);
    commit('reportContOut', {
      items: result.data.object || [],
      total: result.data.total || 0,
      loading: false,
    });

    return result.error ? false : true;
  },

  async getExportReportContainerOut({ commit, state }) {
    commit('reportContOut', {
      loading: true,
    });

    const { data } = state;
    let params = {
      q: data.search,
      page: data.page,
      sort: data.sortBy,
      order: data.sortDesc ? 'desc' : 'asc',
      ...data.form,
      date: '',
      start_date:
        data.form.date && data.form.date.length > 0 && data.form.date[0]
          ? moment(data.form.date[0]).format('YYYY-MM-DD')
          : '',
      end_date:
        data.form.date && data.form.date.length > 0 && data.form.date[1]
          ? moment(data.form.date[1]).format('YYYY-MM-DD')
          : '',
      export: 1,
    };

    let result = await ApiBlobGetRequest(`opr/report/container-out`, params);

    commit('reportContOut', {
      loading: false,
    });

    if (result.error) {
      return false;
    } else {
      // The actual download
      var blob = new Blob([result.data], {
        type:
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });
      var link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = 'report_container_out.xlsx';

      document.body.appendChild(link);

      link.click();
      document.body.removeChild(link);

      return true;
    }
  },
};
